<template>
  <div class="page-container">
    <div class="page-header">
      <h2>项目管理</h2>
      <el-button type="primary" @click="$router.push('/entrust/new')">新建委托</el-button>
    </div>
    <div class="search-bar">
      <el-input v-model="key" placeholder="项目名称/编号" clearable @keyup.enter="load"></el-input>
      <el-select v-model="zt" placeholder="状态" clearable @change="load">
        <el-option label="新建" value="new"></el-option>
        <el-option label="待分配" value="pending"></el-option>
        <el-option label="检测中" value="doing"></el-option>
        <el-option label="已完成" value="done"></el-option>
      </el-select>
      <el-button type="primary" @click="load" style="margin-left:8px">查询</el-button>
    </div>
    <el-table :data="list" v-loading="loading" stripe border size="small">
      <el-table-column prop="xmbh" label="项目编号" width="150"></el-table-column>
      <el-table-column prop="xmmc" label="项目名称" min-width="200"></el-table-column>
      <el-table-column prop="wtdw_mc" label="委托单位" width="180"></el-table-column>
      <el-table-column label="流程" width="100">
        <template slot-scope="{row}">
          <el-tag v-if="row.flow_model === 'RoutineEntrustFlow'" size="small" type="warning">周期</el-tag>
          <el-tag v-else size="small">委托</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="xmfzr_xm" label="负责人" width="100"></el-table-column>
      <el-table-column label="委托状态" width="100">
        <template slot-scope="{row}">
          <el-tag v-if="row.entrust_status" size="small" :type="row.entrust_status === 'submitted' ? 'success' : 'info'">
            {{ row.entrust_status === 'submitted' ? '已提交' : '草稿' }}
          </el-tag>
          <span v-else style="color:#c0c4cc">—</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="{row}">
          <el-tag :type="ztTag(row.xmzt)" size="small">{{ ztLabel(row.xmzt) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="cjsj" label="创建时间" width="160"></el-table-column>
      <el-table-column label="操作" width="280" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="$router.push({ path: '/task-track', query: { xmbh: row.xmbh } })">任务监控</el-button>
          <el-button v-if="row.entrust_status === 'draft'" type="text" size="small" @click="continueEntrust(row)">继续</el-button>
          <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" size="small" @click="del(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="editForm.id?'编辑项目':'新建项目'" :visible.sync="showEdit" width="700px">
      <el-form :model="editForm" label-width="100px" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目编号"><el-input v-model="editForm.xmbh"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报告编号"><el-input v-model="editForm.bgbh"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="项目名称"><el-input v-model="editForm.xmmc"></el-input></el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="委托单位"><el-input v-model="editForm.wtdw_mc"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人"><el-input v-model="editForm.lxr"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="检测类别">
              <el-select v-model="editForm.jclx" style="width:100%">
                <el-option label="企业自检" value="企业自检"></el-option>
                <el-option label="委托检测" value="委托检测"></el-option>
                <el-option label="监督检测" value="监督检测"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目负责人">
              <el-select v-model="editForm.xmfzr_xm" filterable placeholder="选择负责人" clearable style="width:100%">
                <el-option v-for="u in users" :key="u.id" :label="u.xm" :value="u.xm"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'

export default {
  data() {
    return {
      list: [], loading: false, key: '', zt: '',
      showEdit: false, editForm: {}, users: []
    }
  },
  async mounted() {
    this.load()
    const res = await api.get('yn_yh_list')
    this.users = res.data || []
  },
  methods: {
    async load() {
      this.loading = true
      const params = {}
      if (this.key) params.key = this.key
      if (this.zt) params.zt = this.zt
      const res = await api.get('yn_xm_list', params)
      this.list = res.data || []
      this.loading = false
    },
    openEdit(row) {
      this.editForm = row ? { ...row } : { xmbh: '', xmmc: '', wtdw_mc: '', lxr: '', lxdh: '', jclx: '企业自检', xmfzr_xm: '', xmzt: 'new' }
      this.showEdit = true
    },
    async save() {
      await api.post('yn_xm_save', this.editForm)
      this.showEdit = false; this.load()
    },
    async del(row) {
      const name = row.xmmc || row.xmbh || '该项目'
      await this.$confirm(
        `确认删除「${name}」？将同时删除关联的任务派遣、六套表单、样品数据、项目照片、检测报告等，且不可恢复。`,
        '警告',
        { type: 'warning' }
      )
      const res = await api.get('yn_xm_del', { id: row.id })
      const msg = typeof res.data === 'string' ? res.data : ''
      if (msg.startsWith('22')) {
        this.$message.error(msg.slice(3) || '删除失败')
        return
      }
      this.$message.success('已删除项目及关联数据')
      this.load()
    },
    continueEntrust(row) {
      const base = row.flow_model === 'RoutineEntrustFlow' ? '/routine/' : '/entrust/'
      this.$router.push(base + encodeURIComponent(row.xmbh))
    },
    ztTag(v) { return { new: 'info', pending: 'warning', doing: 'primary', done: 'success', pending_audit: 'warning', audit_pass: 'success', plan_ready: 'warning', dispatched: 'primary' }[v] || 'info' },
    ztLabel(v) {
      const m = { new: '新建', pending: '待分配', doing: '检测中', done: '已完成', pending_audit: '待审核', audit_pass: '审核通过', plan_ready: '待周期安排', dispatched: '已派遣' }
      return m[v] || v
    }
  }
}
</script>
